module.exports = __webpack_public_path__ + "img/arissa-header.47606691.svg";